import { Box, ThemeContext } from '@vouched.id/vault';
import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { ApprovedIcon } from '../../Icons/Approved';
import { RejectedIcon } from '../../Icons/Rejected';
const reviewIconStyle = { cursor: 'pointer' };
export const ReviewIcon = ({ label, originalResultIcon, reviewItems, handleReviewUpdate }) => {
    const isAdminRoute = useLocation().pathname.includes('/admin');
    const { tokens } = useContext(ThemeContext).theme;
    if (typeof reviewItems[label] === 'boolean') {
        return (React.createElement(Box, { onClick: isAdminRoute
                ? undefined
                : () => {
                    handleReviewUpdate({ [label]: null });
                }, style: isAdminRoute ? undefined : reviewIconStyle }, reviewItems[label] ? React.createElement(ApprovedIcon, null) : React.createElement(RejectedIcon, null)));
    }
    if (originalResultIcon.type === ApprovedIcon) {
        return (React.createElement(Box, { onClick: isAdminRoute
                ? undefined
                : () => {
                    handleReviewUpdate({ [label]: false });
                }, style: isAdminRoute ? undefined : reviewIconStyle },
            React.createElement(RejectedIcon, { fill: tokens.colors.gray300 })));
    }
    return (React.createElement(Box, { onClick: isAdminRoute
            ? undefined
            : () => {
                handleReviewUpdate({ [label]: true });
            }, style: isAdminRoute ? undefined : reviewIconStyle },
        React.createElement(ApprovedIcon, { fill: tokens.colors.gray300 })));
};
